var _defs, _g, _g2, _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYtIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff7f0;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        fill-rule: evenodd;\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "67.32 63.36 87.39 74.9 67.32 86.59 67.32 63.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M119.26,30.75c-11.33-11.33-26.97-18.33-44.25-18.33-34.57,0-62.59,28.02-62.59,62.58s28.02,62.58,62.59,62.58,62.58-28.02,62.58-62.58c0-17.28-7-32.92-18.33-44.25ZM112.73,90.19c-1.2,8.99-5.7,10.34-14.54,11.09-1.43.14-2.9.26-4.39.36-6.45.44-13.21.54-18.69.54-6.75,0-15.59-.15-23.08-.9-8.85-.75-13.49-2.1-14.69-11.09-.52-5.08-.77-10.19-.75-15.29-.02-5.11.23-10.21.75-15.29,1.2-8.84,5.84-10.34,14.69-11.09,7.49-.6,16.33-.9,23.08-.9s15.43.3,23.08.9c8.84.75,13.34,2.25,14.54,11.09.65,5.07.95,10.18.9,15.29.05,5.11-.25,10.22-.9,15.29Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "87.39 74.9 67.32 86.59 67.32 63.36 87.39 74.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "67.32 63.36 87.39 74.9 67.32 86.59 67.32 63.36"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "87.39 74.9 67.32 86.59 67.32 63.36 87.39 74.9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYtIcon);
export default __webpack_public_path__ + "static/media/ytIcon.b24843edc0d1937fc3e55b92db5bd080.svg";
export { ForwardRef as ReactComponent };